import { apiCall } from "./Interceptor";

const ALL_CITY = "/city/getAll/public";
const ALL_STATE = "/stateAndUt/getAll/public";
const CITY_BY_STATE = "/city/getByState/public";

const getAllCity = async () => {
    const response = await apiCall.get(ALL_CITY);
    return response;
}

const getAllState = async (id) => {
    const response = await apiCall.get(ALL_STATE + (id ? `?regionId=${id}` :''));
    return response;
  }  

const getCityByState = async (id) => {
    const response = await apiCall.get(`${CITY_BY_STATE}?stateId=${id}`);
    return response;
}

export default {
    getAllCity,
    getAllState,
    getCityByState
};
